import { ActionReducer, MetaReducer } from '@ngrx/store';
import { RootState } from './store.state';
import { clearState } from '../shared/store/shared.actions';

export function clearStateMetaReducer(
    reducer: ActionReducer<RootState>
): ActionReducer<RootState> {
    return (state, action) => {
        if (action.type === clearState.type) {
            // preserve `auth` slice, reset everything else
            const authState = state?.auth;

            /* // returning undefined will make each feature reducer fall back to its initialState
                return reducer(undefined, { type: '@@INIT' }); */
            return reducer(
                {
                    auth: authState // keep auth as-is
                } as RootState,
                { type: '@@INIT' }
            );
        }
        return reducer(state, action);
    };
}

export const metaReducers: MetaReducer<RootState>[] = [clearStateMetaReducer];
